import { render, staticRenderFns } from "./components-sidebar.vue?vue&type=template&id=5e1e3c66&scoped=true&"
import script from "./components-sidebar.vue?vue&type=script&lang=js&"
export * from "./components-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./components-sidebar.vue?vue&type=style&index=0&id=5e1e3c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e3c66",
  null
  
)

export default component.exports